//Mixin to display errors from axios calls
const displayError = error => {
    $("#alertMsg").text(error);
    $("#alertTop").modal("open");
    $(".loading").hide();
  };
  
  module.exports = displayError;